import { Result, StatsObject } from '../types'
import calculateScore from './calculateScore'

// --------- Unique to OWS ----------
const SCORE_DISTRIBUTION_ELEMENTS = 5
// ----------------------------------

const INITIAL_STATS_OBJECT: StatsObject = { p: 0, sk: 0, b: 0, l: 0, s: 0, dst: [], bt: 0 }
// p = played
// sk = streak
// b = best streak
// l = last played
// s = stars
// dst = distribution of stars
// bt = best time

for (let i = 0; i < SCORE_DISTRIBUTION_ELEMENTS; i++) {
	INITIAL_STATS_OBJECT.dst.push(0)
}

export default function calculateNewStatsObject(prevStats: StatsObject, newResult: Result) {
	let newStats = { ...INITIAL_STATS_OBJECT }
	if (prevStats) newStats = { ...newStats, ...prevStats }

	newStats.dst = [...newStats.dst]

	if (!newResult) return newStats

	const { i: index, time } = newResult

	if (index > 0 && index <= newStats.l) return newStats

	// --------- Unique to OWS ----------
	if (newStats.l === index - 1 || newStats.sk === 0) {
		newStats.sk += 1 // Increase current streak
		newStats.b = Math.max(newStats.b, newStats.sk) // Update best streak if needed
	} else {
		newStats.sk = 1 // Reset current streak
	}
	if (!newStats.bt || time < newStats.bt) {
		newStats.bt = time // Update best time
	}
	// ----------------------------------

	newStats.p += 1
	newStats.l = index

	// --------- Unique to OWS ----------
	const stars = calculateScore(time)
	newStats.dst[stars - 1] += 1

	// Calculate total number of stars earned
	newStats.s = newStats.dst.reduce((acc, val, i) => acc + val * (i + 1), 0)
	// ----------------------------------

	return newStats
}
